var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneConversation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.838,
    height: 31.814,
    viewBox: "0 0 31.838 31.814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#666;stroke:#666;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.271 0.344)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M31.4,25.1l-6.319-4.214a1.844,1.844,0,0,0-2.47.4l-1.841,2.367a.787.787,0,0,1-1.009.212l-.35-.193A21.161,21.161,0,0,1,13.9,19.344a21.248,21.248,0,0,1-4.332-5.515l-.192-.35a.788.788,0,0,1,.208-1.012l2.365-1.84a1.845,1.845,0,0,0,.4-2.47L8.136,1.837A1.835,1.835,0,0,0,5.662,1.28L3.02,2.868a3.728,3.728,0,0,0-1.7,2.206C.368,8.541,1.084,14.525,9.9,23.341c7.012,7.011,12.232,8.9,15.82,8.9a9.218,9.218,0,0,0,2.445-.319,3.724,3.724,0,0,0,2.206-1.7l1.589-2.641A1.835,1.835,0,0,0,31.4,25.1Zm-.34,1.941-1.585,2.643a2.689,2.689,0,0,1-1.587,1.23c-3.2.879-8.793.151-17.255-8.312S1.445,8.55,2.324,5.349A2.693,2.693,0,0,1,3.555,3.76L6.2,2.175a.8.8,0,0,1,1.073.241L9.56,5.853l1.921,2.882a.8.8,0,0,1-.174,1.072l-2.366,1.84a1.821,1.821,0,0,0-.482,2.337l.188.341a22.072,22.072,0,0,0,4.51,5.754,22.1,22.1,0,0,0,5.754,4.509l.342.188A1.821,1.821,0,0,0,21.59,24.3l1.84-2.366a.8.8,0,0,1,1.072-.174l6.319,4.214A.8.8,0,0,1,31.063,27.044Z",
    transform: "translate(-1 -1.018)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M283.148,70.365a8.855,8.855,0,0,1,8.845,8.845.52.52,0,1,0,1.041,0,9.9,9.9,0,0,0-9.885-9.885.52.52,0,0,0,0,1.041Z",
    transform: "translate(-265.457 -65.159)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M283.148,121.565a5.73,5.73,0,0,1,5.723,5.723.52.52,0,0,0,1.041,0,6.772,6.772,0,0,0-6.764-6.764.52.52,0,0,0,0,1.041Z",
    transform: "translate(-265.457 -113.238)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M283.148,172.765a2.6,2.6,0,0,1,2.6,2.6.52.52,0,0,0,1.041,0,3.646,3.646,0,0,0-3.642-3.642.52.52,0,0,0,0,1.041Z",
    transform: "translate(-265.457 -161.316)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneConversation);
export default __webpack_public_path__ + "static/media/phone-conversation.42952d83d5512de71ad7d34b62860e4e.svg";
export { ForwardRef as ReactComponent };